import request from '@/utils/request';

export function orderInfos(params) {
  return request({
    url: '/api/guarantee',
    method: 'get',
    headers: {
      'Cache-control': 'no-cache',
      Pragma: 'no-cache',
    },
    params,
  });
}

export function cetRandom(params) {
  return request({
    url: '/api/accCertification/cetRandom',
    method: 'get',
    params,
  });
}
export function certVerify(params) {
  return request({
    url: '/api/accCertification/certVerify',
    method: 'post',
    params,
  });
}
export function orderInfoGive(params) {
  return request({
    url: '/orderInfoApi/orderInfoGive',
    method: 'post',
    params,
  });
}
export function getOrderInfos(params) {
  return request({
    url: '/api/apply/sections',
    method: 'get',
    params,
  });
}
export function postInsureApply(data) {
  return request({
    url: '/api/apply/insureApply',
    method: 'post',
    data,
  });
}
export function postApplyInsureApplyInfo(data) {
  return request({
    url: '/api/apply/insureApplyInfo',
    method: 'post',
    data,
  });
}
export function getProcurementCompany(params) {
  return request({
    url: '/api/dictDetail?dictName=procurementCompany',
    method: 'get',
    params,
  });
}
export default { orderInfos, cetRandom, certVerify, orderInfoGive ,getOrderInfos,postInsureApply,postApplyInsureApplyInfo,getProcurementCompany};
